import { defineComponent as _defineComponent } from 'vue'
import { Price } from '@/api/api-billing';
import { PropType, computed } from 'vue';
import { subscriptionPriceInfo, SubscriptionPriceInfo } from '@/services/billing-utils';
import { TranslateResult } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlanDetailsCard',
  props: {
  isLowest: { type: Boolean, required: false, default: false },
  features: { type: Array as PropType<Array<string|TranslateResult>>, required: true },
  price: { type: Object as PropType<Price>, required: true },
  showDiscount: { type: Boolean, required: false, default: false },
  disabled: { type: Boolean, required: false, default: false },
  currentPlan: { type: Boolean, required: false, default: false },
  unavailablePlan: { type: Boolean, required: false, default: false },
},
  emits: ['plan-selected'],
  setup(__props, { emit }) {

const props = __props;




const priceInfo = computed<SubscriptionPriceInfo>(() => subscriptionPriceInfo(props.price));

const integerPart = (amt: string) => amt.split('.')[0];
const fractionPart = (amt: string) => amt.split('.')[1];


return { __sfc: true,emit, props, priceInfo, integerPart, fractionPart }
}

})